module.exports = __webpack_public_path__ + "img/calendar-x.a3f103f9.svg";